import { z } from 'zod';

export const UpgradePlanPromotionSchema = z
  .object({
    planGroupId: z.number().optional(),
    currentPlanId: z.number().optional(),
    currentPlanGroupId: z.number().optional(),
    recommendedPlanGroupId: z.number().optional(),
    recommendedPlanId: z.number().optional(),
    recommended3PlPlanGroupId: z.number().optional(),
    recommended3PlPlanId: z.number().optional(),
  })
  .passthrough();

export type UpgradePlanPromotion = z.infer<typeof UpgradePlanPromotionSchema>;
